import { daysInclusive, isCalendarDateKey, lastCompleteMonth } from "@gately/validators";

export type ReportScope = { kind: "unit"; id: string } | { kind: "gate"; id: string };
export interface ReportSearch {
  from?: string;
  to?: string;
  unit?: string;
  gate?: string;
}

const str = (v: unknown) => (typeof v === "string" && v.length > 0 ? v : undefined);

/** Same wording and limit as the server's `customRangeIssue`. */
export function rangeIssue(from: string, to: string): string | null {
  if (to < from) return "La date de fin précède la date de début.";
  if (daysInclusive(from, to) > 367) return "Plage limitée à 366 jours.";
  return null;
}

export function parseReportSearch(raw: Record<string, unknown>): ReportSearch {
  const out: ReportSearch = {};
  const from = str(raw.from);
  const to = str(raw.to);
  if (from && to && isCalendarDateKey(from) && isCalendarDateKey(to) && rangeIssue(from, to) === null) {
    out.from = from;
    out.to = to;
  }
  const unit = str(raw.unit);
  const gate = str(raw.gate);
  if (unit) out.unit = unit;
  else if (gate) out.gate = gate;
  return out;
}

export function resolveReportSearch(search: ReportSearch, todayKey: string) {
  const range = search.from && search.to ? { from: search.from, to: search.to } : lastCompleteMonth(todayKey);
  const scope: ReportScope | undefined = search.unit
    ? { kind: "unit", id: search.unit }
    : search.gate
      ? { kind: "gate", id: search.gate }
      : undefined;
  return scope ? { ...range, scope } : range;
}
